// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1at8e","inputWrap":"CustomTip_inputWrap__22XHL"};